export const round = (number, decimals) => {
  const numberParsed = parseFloat(number);
  if (!number || isNaN(numberParsed)) return number;
  return parseFloat(numberParsed.toFixed(decimals || 2));
};

export const findUrlForMedia = (media, format) => {
  if (!media || !media.formats) return null;
  else if (!format) return media.url;

  const foundFormat = media?.formats[format];
  return foundFormat?.url || media.url;
};
